module.exports = __webpack_public_path__ + "6e1ddfed.woff2";